import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoginPage from "@/pages/LoginPage";
import DashboardLayout from "@/pages/DashboardLayout";
import DashboardHome from "@/pages/DashboardHome";
import SuratPage from "@/pages/SuratPage";
import BuatSuratPage from "@/pages/BuatSuratPage";
import UsersPage from "@/pages/UsersPage";
import PengaturanPage from "@/pages/PengaturanPage";
import AuditLogPage from "@/pages/AuditLogPage";
import KaryawanDashboard from "@/pages/KaryawanDashboard";
import AttendanceRecapPage from "@/pages/AttendanceRecapPage";
import AttendanceSettingsPage from "@/pages/AttendanceSettingsPage";
import IzinPage from "@/pages/IzinPage";
import ProductsPage from "@/pages/ProductsPage";
import CompanySettingsPage from "@/pages/CompanySettingsPage";
import DailyStatsPage from "@/pages/DailyStatsPage";
import VerifyPage from "@/pages/VerifyPage";
import ReportPage from "@/pages/ReportPage";
import BrandingPage from "@/pages/BrandingPage";
import SalesTrainingPage from "@/pages/SalesTrainingPage";
import AIAssistantPage from "@/pages/AIAssistantPage";
import "@/App.css";

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex h-screen items-center justify-center text-sm text-ink-500">
        Memuat sesi…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    // Redirect to safe home page for their role
    const home = user.role === "karyawan" ? "/absensi" : "/dashboard";
    return <Navigate to={home} replace />;
  }
  return children;
}

function HomeRedirect() {
  const { user } = useAuth();
  if (user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  return user.role === "karyawan" ? <Navigate to="/absensi" replace /> : <Navigate to="/dashboard" replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/verify/:code" element={<VerifyPage />} />
          <Route
            path="/"
            element={
              <Protected>
                <DashboardLayout />
              </Protected>
            }
          >
            <Route index element={<HomeRedirect />} />
            {/* Admin & Surat-User routes */}
            <Route path="dashboard" element={<Protected roles={["admin", "user"]}><DashboardHome /></Protected>} />
            <Route path="surat" element={<Protected roles={["admin", "user"]}><SuratPage /></Protected>} />
            <Route path="surat/baru" element={<Protected roles={["admin", "user"]}><BuatSuratPage /></Protected>} />
            <Route path="users" element={<Protected roles={["admin"]}><UsersPage /></Protected>} />
            <Route path="pengaturan" element={<Protected roles={["admin"]}><PengaturanPage /></Protected>} />
            <Route path="produk" element={<Protected roles={["admin"]}><ProductsPage /></Protected>} />
            <Route path="perusahaan" element={<Protected roles={["admin"]}><CompanySettingsPage /></Protected>} />
            <Route path="statistik" element={<Protected roles={["admin","user"]}><DailyStatsPage /></Protected>} />
            <Route path="report" element={<Protected roles={["admin"]}><ReportPage /></Protected>} />
            <Route path="branding" element={<Protected roles={["admin"]}><BrandingPage /></Protected>} />
            <Route path="sales-training" element={<Protected roles={["admin","user","karyawan"]}><SalesTrainingPage /></Protected>} />
            <Route path="ai-assistant" element={<Protected roles={["admin","user","karyawan"]}><AIAssistantPage /></Protected>} />
            <Route path="audit" element={<Protected roles={["admin"]}><AuditLogPage /></Protected>} />

            {/* Karyawan & shared routes */}
            <Route path="absensi" element={<Protected roles={["karyawan"]}><KaryawanDashboard /></Protected>} />
            <Route path="izin" element={<Protected roles={["karyawan", "admin"]}><IzinPage /></Protected>} />
            <Route path="rekap-absensi" element={<Protected roles={["admin"]}><AttendanceRecapPage /></Protected>} />
            <Route path="pengaturan-absensi" element={<Protected roles={["admin"]}><AttendanceSettingsPage /></Protected>} />
          </Route>
          <Route path="*" element={<HomeRedirect />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
